module.exports = "/assets/e5344fb821f5d185e6f5262b777d47ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EL.png
// module id = 1340
// module chunks = 0